"use client"

import { SelectCategory } from "@/components/select-category"
import { ComponentConfig } from "@measured/puck"
import { RenderConfig } from "./RenderConfig"

export type VideoCategoryGridLayoutProps = {
  category:
    | {
        categoryId: string
        categoryName?: string
        slug?: string
        playlistUrl?: string
      }
    | string
}

export const VideoCategoryGridLayout = {
  label: "Tamda Media | VideoCategoryGridLayout",
  fields: {
    category: {
      type: "custom",
      label: "Category",
      render: props => <SelectCategory {...props} />,
    },
  },
  defaultProps: {
    category: "",
  },
  ...RenderConfig,
} as ComponentConfig<VideoCategoryGridLayoutProps>
